import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import CompanyIndex from './views/dashboard/company/Index.vue'
import CompanyCreate from './views/dashboard/company/Create.vue'
import CompanyUpdate from './views/dashboard/company/Update.vue'
import ShipperUpdate from './views/dashboard/shipper/Update.vue'

import QuoteIndex from './views/dashboard/quote/Index.vue'
import QuoteDetail from './views/dashboard/quote/Detail.vue'

import EmailCreate from './views/dashboard/email/Create.vue'

import HomeIndex from './views/dashboard/home/Index.vue'

import UserIndex from './views/dashboard/user/Index.vue'

const DefaultContainer = () => import('@/containers/DefaultContainer')

Vue.use(Router)

const unAuth = (to, from, next) => {
  if (window.$cookies.isKey('token')) {
    next(
      { name: 'mainPage' }
    )
  } else {
    next()
  }
}

const auth = (to, from, next) => {
  if (!window.$cookies.isKey('token')) {
    next(
      { name: 'login' }
    )
  } else {
    next()
  }
}

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: unAuth
    },
    {
      path: '/dashboard',
      redirect: '/dashboard/home',
      component: DefaultContainer,
      beforeEnter: auth,
      children: [
        {
          path: 'company',
          name: 'บริษัท',
          redirect: '/dashboard/company/index',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'index',
              name: 'บริษัททั้งหมด',
              component: CompanyIndex
            },
            {
              path: 'create',
              name: 'สร้างบริษัท',
              component: CompanyCreate
            },
            {
              path: 'update/:companyId',
              name: 'อัพเดทบริษัท',
              component: CompanyUpdate
            },
            {
              path: 'update-shipper/:companyId',
              name: 'อัพเดทบริษัท-shipper',
              component: ShipperUpdate
            }
          ]
        },
        {
          path: 'user',
          name: 'ผู้ใช้งาน',
          redirect: '/dashboard/user/index',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'index',
              name: 'บริษัททั้งหมด',
              component: UserIndex
            }
          ]
        },
        {
          path: 'quote',
          name: 'งาน',
          redirect: '/dashboard/quote/index',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'index',
              name: 'งานทั้งหมด',
              component: QuoteIndex
            },
            {
              path: ':quoteId',
              name: 'รายละเอียดงาน',
              component: QuoteDetail
            }
          ]
        },
        {
          path: 'email',
          name: 'email',
          redirect: '/dashboard/email/create',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'create',
              name: 'ส่งอีเมล',
              component: EmailCreate
            }
          ]
        },
        {
          path: 'home',
          name: 'mainPage',
          redirect: '/dashboard/home/index',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'index',
              name: 'ภาพรวม',
              component: HomeIndex
            }
          ]
        }
      ]
    }
  ]
})
